import { render, staticRenderFns } from "./zoom.vue?vue&type=template&id=6ff8cad5&scoped=true&lang=true&"
import script from "./zoom.vue?vue&type=script&lang=js&"
export * from "./zoom.vue?vue&type=script&lang=js&"
import style0 from "./zoom.vue?vue&type=style&index=0&id=6ff8cad5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff8cad5",
  null
  
)

export default component.exports